import React, { useContext, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { GlobalContext } from "../context/GlobalContext";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import axios from "axios";

const Register = () => {
  const navigate = useNavigate();
  const { contextState } = useContext(GlobalContext);
  const { setIsLoggedIn } = contextState;
  const [role, setRole] = useState("");
  const [input, setInput] = useState({
    nip: "",
    nama: "",
    email: "",
    password: "",
  });

  const setRoleFun = (event) => {
    setRole(event.target.value);
  };

  const handleChange = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    setInput({ ...input, [name]: value });
  };

  const inputValidation = (nip, nama, email, password) => {
    const pattern = /[0-9]|\./;
    if (
      email === "" ||
      nip === "" ||
      password === "" ||
      role === "" ||
      nama === ""
    ) {
      Swal.fire({
        title: "Error!",
        text: "Inputan tidak boleh kosong!",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });

      return false;
    } else {
      console.log(nama);
      if (!pattern.test(nip)) {
        Swal.fire({
          title: "Error!",
          text: "NIP harus berupa nomor!",
          icon: "error",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
        return false;
      } else if (nama.length < 6) {
        Swal.fire({
          title: "Error!",
          text: "Nama terlalu pendek!",
          icon: "error",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
        return false;
      } else if (password.length <= 7) {
        Swal.fire({
          title: "Error!",
          text: "Password terlalu pendek!",
          icon: "error",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
        return false;
      }
    }
  };

  const handleRegister = (event) => {
    event.preventDefault();
    let { nip, nama, email, password } = input;
    if (inputValidation(nip, nama, email, password) == false) {
      console.log(inputValidation(nip, nama, email, password));
    } else {
      axios
        .post("https://productspec.cyclic.app/register", {
          nip,
          nama,
          role,
          email,
          password,
        })
        .then((res) => {
          let data = res.data;
          setIsLoggedIn(true);
          Cookies.set("token", data.token, { expires: 1 });
          Cookies.set("user", JSON.stringify(data.user), { expires: 1 });
          navigate("/");
        })

        .catch((error) => {
          alert(error.response.data);
        });
    }
  };

  return (
    <div className="d-flex justify-content-center page-add">
      <div className="user-container">
        <form onSubmit={handleRegister}>
          <h2 className="text-center fw-bold">Register</h2>
          <div className="form-group">
            <label htmlFor="nip" className="form-label">
              NIP
            </label>
            <input
              className="form-control"
              name="nip"
              onChange={handleChange}
              value={input.nip}
              type="nip"
              placeholder="nip"
            />
          </div>
          <div className="form-group">
            <label htmlFor="nama" className="form-label">
              Nama
            </label>
            <input
              className="form-control"
              name="nama"
              onChange={handleChange}
              value={input.nama}
              type="nama"
              placeholder="nama"
            />
          </div>

          <div className="mt-2" onChange={setRoleFun}>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="role"
                id="inlineRadio1"
                value="rnd"
              />
              <label className="form-check-label" htmlFor="inlineRadio1">
                R&D
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="role"
                id="inlineRadio2"
                value="prod"
              />
              <label className="form-check-label" htmlFor="inlineRadio2">
                Produksi
              </label>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              className="form-control"
              name="email"
              onChange={handleChange}
              value={input.email}
              type="email"
              placeholder="Email"
            />
          </div>
          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              className="form-control"
              name="password"
              onChange={handleChange}
              value={input.password}
              type="password"
              placeholder="Password"
            />
            <p className="float-start mt-3">
              Sudah punya akun?{" "}
              <Link to="/login">
                <span className="link-redirect">Login</span>
              </Link>
            </p>
            <button
              className="btn btn-success rounded-pill float-end mt-3"
              type="submit"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;
